export default "__VITE_ASSET__Bzn9mvxP__"